import { Component, EventEmitter, input, Output } from '@angular/core';
import { SectionHeaderComponent } from '../section-header/section-header.component';
import { PrimaryButtonComponent } from '../primary-button/primary-button.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SectionTitleComponent } from '../section-title/section-title.component';

@Component({
  standalone: true,
  imports: [
    SectionHeaderComponent, PrimaryButtonComponent, TranslocoModule,
    SectionTitleComponent,
  ],
  selector: 'app-category-section-header',
  templateUrl: './category-section-header.component.html',
})
export class CategorySectionHeaderComponent {
  public readonly title = input.required<string>();

  @Output() public readonly showAll = new EventEmitter<void>();

  onShowAll(): void {
    this.showAll.emit();
  }
}
